// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-webpage-js": () => import("./../src/webpage.js" /* webpackChunkName: "component---src-webpage-js" */)
}

